import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import { tokens } from "../theme";

const disp = '"Space Grotesk", sans-serif';
const mono = '"IBM Plex Mono", monospace';

// Compact KPI tile (SpinSaga miniK style) with optional colored accent bar.
export default function MiniStat({ label, value, delta, up, color, note }) {
  return (
    <Box
      sx={{
        height: "100%",
        background: tokens.cardBg,
        border: `1px solid ${tokens.border}`,
        borderRadius: "12px",
        p: "13px 15px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {color && (
        <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, bgcolor: color }} />
      )}
      <Typography sx={{ color: tokens.textDim, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 600 }}>
        {label}
      </Typography>
      <Typography sx={{ fontFamily: disp, fontSize: 24, fontWeight: 600, mt: 0.7, letterSpacing: "-0.02em" }}>
        {value}
      </Typography>
      {delta != null && (
        <Typography
          sx={{
            fontFamily: mono,
            fontSize: 11.5,
            fontWeight: 600,
            mt: 0.4,
            color: up ? tokens.secondary : tokens.danger,
            display: "flex",
            alignItems: "center",
            gap: 0.3,
          }}
        >
          {up ? <ArrowUpwardRoundedIcon sx={{ fontSize: 13 }} /> : <ArrowDownwardRoundedIcon sx={{ fontSize: 13 }} />}
          {delta}
        </Typography>
      )}
      {note && (
        <Typography sx={{ fontFamily: mono, fontSize: 11, color: tokens.textDim2 || tokens.textDim, mt: 0.4 }}>
          {note}
        </Typography>
      )}
    </Box>
  );
}
